import PostHog from "@/services/analytics/postHog";
import FacebookPixel from "@/services/analytics/facebookPixel";
import Gtm from "@/services/analytics/gtm";

// Business events that get reported to multiple analytics tools at once (PostHog, Meta Pixel, GTM/Google Ads, ...) live here instead of
// in components, so components stay focused on UI logic. Adding another tool for an already tracked event then means changing one
// function here, not hunting down every call site.

export const trackRegistrationDone = (): void => {
  Gtm.trackEvent({ event: Gtm.Event.RegistrationDone });
  PostHog.trackEvent(PostHog.EventName.Registration_Done);
  FacebookPixel.trackEvent(FacebookPixel.Event.CompleteRegistration);
};

export const trackAddToCart = (): void => {
  PostHog.trackEvent(PostHog.EventName.Marketplace_ToCartBtn_User_Click);
  FacebookPixel.trackEvent(FacebookPixel.Event.AddToCart);
  Gtm.trackEvent({ event: Gtm.Event.AddToCart });
};

export const trackViewCart = (): void => {
  Gtm.trackEvent({ event: Gtm.Event.ViewCart });
};

export const trackPurchase = (value: number, currency: string): void => {
  FacebookPixel.trackEvent(FacebookPixel.Event.NewOrder, { value, currency });
  Gtm.trackEvent({ event: Gtm.Event.Purchase, ecommerce: { value, currency } });
};
